<template>
  <div class="language-user" v-loading="loading">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ $t("head.user") }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="language-main">
      <div v-for="(item, index) in languageLists" :key="index" class="main-item" @click="changeLanguageType(item)">
        <p>{{ item.name }}</p>
        <van-icon v-if="languageType == item.type" name="success" size="28" color="#FFC400" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      languageType: "",//当前选中语言
      languageLists: '',//语言列表
      loading: false,//切换语言加载动画
    };
  },
  async mounted() {
    this.languageType = await localStorage.getItem('language') || 'Chinese'
    this.languageLists = this.$t("lang.langlist")
    console.log(this.$t("lang.langlist"))
  },
  methods: {
    changeLanguageType(item) {
      let _this = this
      _this.languageType = item;
      localStorage.setItem("language", item.type);
      _this.loading = true;
      setTimeout(() => {
        _this.$i18n.locale = item.type;
        _this.languageType = localStorage.getItem('language') || 'Chinese'
        _this.languageLists = this.$t("lang.langlist")
        _this.reload();
        _this.loading = false;
      }, 1000);
    },
    toBack() {
      this.$router.go("-1");
    },
  },
};
</script>

<style lang="scss" scoped>
.language-user {
  width: 100vw;
  height: var(--height);
  overflow-x: hidden;
  overflow-y: scroll;
  background: #0c0b0b;
  min-height: 100vh;

  .language-main {
    padding: 0 0.9375rem;

    .main-item {
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.0625rem solid #272727;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/user/language.vue